import React from 'react';
import './App.css'; 
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import Contact from './Components/Contact';
import AboutPage from './Components/AboutPage';
import GalleryPage from './Components/GalleryPage';
//import Services from './Components/Services';
import Sidebar from './Components/Sidebar';
import FAQ from './Components/FAQ';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';
import WhatsAppButton from './Components/WhatsAppButton';
import { HelmetProvider } from 'react-helmet-async';
function App() {
  return (
     <HelmetProvider>
    <div className="App">
    <Router>
            <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home/> } />
        <Route path="/Services" element={<Sidebar />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/AboutPage" element={<AboutPage />} />
        <Route path="/GalleryPage" element={<GalleryPage />} />
        <Route path="/FAQ" element={<FAQ />} />
        <Route path="/Service/:serviceParam" element={<Sidebar />} />
      </Routes>
      <WhatsAppButton />
      <Footer />
    </Router>
    </div>
    </HelmetProvider>
  );
}

export default App;

// import React from 'react';
// import Navbar from './components/Navbar';
// import './App.css'; // Add some basic styles for the background

// function App() {
//   return (
//     <div className="App">
//       <Navbar />
//       <header className="hero-section">
//         <h1>Welcome to the Page</h1>
//         <p>The navbar above has a transparent background.</p>
//       </header>
//       {/* Add more content here */}
//     </div>
//   );
// }

// export default App;